import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  size = 'md',
  icon,
  className = ''
}: BadgeProps) {
  const variants = {
    default: 'bg-slate-800 text-slate-300 border-slate-700',
    primary: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/20',
    success: 'bg-green-500/10 text-green-400 border-green-500/20',
    warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
    danger: 'bg-red-500/10 text-red-400 border-red-500/20',
    info: 'bg-blue-500/10 text-blue-400 border-blue-500/20'
  };
  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 sm:px-3 py-1 text-xs sm:text-sm',
    lg: 'px-3 sm:px-4 py-1 sm:py-1.5 text-sm sm:text-base'
  };
  return <span className={`inline-flex items-center rounded-full border font-medium max-w-full ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-641">
      {icon && <span className="mr-1 sm:mr-1.5 flex-shrink-0" data-id="element-642">{icon}</span>}
      <span className="truncate" data-id="element-643">{children}</span>
    </span>;
}